/**
 * Lista de referencia para valores de los estados de las vacantes
 * 
 */
export const StatusAccompanimentModel = [
    { code: 'GESTION', value: 'Gestión' },
    { code: 'CERRADO', value: 'Cerrado' },

];